import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { QuestionnaireEditModule } from "@/modules/newCommunity/pages/operationTools/dynimicStore";
let sex = class sex extends Vue {
  constructor() {
    super(...arguments);
    this.answer = "";
  }
  dataChage(value) {
    this.zItem = value;
    if (this.viewMode == "ANSWERREVIEW") {
      if (value.answer) {
        this.answer = value.answer;
      }
    }
  }
  get questionnaireType() {
    return this.businessType || QuestionnaireEditModule.questionnaireType;
  }
};
__decorate([Prop({
  type: String,
  default: "EDIT"
})], sex.prototype, "viewMode", void 0);
__decorate([Prop({
  type: Number,
  default: 0
})], sex.prototype, "zIndex", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], sex.prototype, "showScore", void 0);
__decorate([Prop({
  type: String,
  default: ""
})], sex.prototype, "businessType", void 0);
__decorate([Prop({
  type: Boolean,
  default: true
})], sex.prototype, "Required", void 0);
__decorate([Watch("zIndex", {
  immediate: true
})
// eslint-disable-next-line
// watchIndex() {}
, Prop({
  type: Object,
  default: {}
})], sex.prototype, "item", void 0);
__decorate([Watch("item", {
  immediate: true,
  deep: true
})], sex.prototype, "dataChage", null);
sex = __decorate([Component({
  name: "sex"
})], sex);
export default sex;